import { User } from '../types/auth';

const API_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:6001/api';

export interface LoginResponse {
  token: string;
  usuario: User;
}

export interface GoogleLoginData {
  token: string;
  tipo: 'paciente' | 'nutricionista';
}

class AuthService {
  private token: string | null = null;

  constructor() {
    this.token = localStorage.getItem('token');
  }

  async login(email: string, senha: string): Promise<LoginResponse> {
    const response = await fetch(`${API_URL}/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, senha }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Erro no login');
    }

    const data = await response.json();
    this.setToken(data.token);
    return data;
  }

  async googleLogin(googleToken: string, tipo: 'paciente' | 'nutricionista'): Promise<LoginResponse> {
    const response = await fetch(`${API_URL}/auth/google`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token: googleToken, tipo }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Erro no login com Google');
    }

    const data = await response.json();
    this.setToken(data.token);
    return data;
  }

  async register(nome: string, email: string, senha: string, tipo: 'paciente' | 'nutricionista', telefone: string): Promise<LoginResponse> {
    const response = await fetch(`${API_URL}/auth/registro`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ nome, email, senha, tipo, telefone }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Erro no cadastro');
    }

    const data = await response.json();
    this.setToken(data.token);
    return data;
  }

  async getProfile(): Promise<User> {
    if (!this.token) {
      throw new Error('Token não encontrado');
    }

    const response = await fetch(`${API_URL}/auth/perfil`, {
      headers: {
        'Authorization': `Bearer ${this.token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Erro ao buscar perfil');
    }

    return await response.json();
  }

  async updateProfile(nome?: string, telefone?: string): Promise<User> {
    if (!this.token) {
      throw new Error('Token não encontrado');
    }

    const response = await fetch(`${API_URL}/auth/perfil`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.token}`,
      },
      body: JSON.stringify({ nome, telefone }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Erro ao atualizar perfil');
    }

    return await response.json();
  }

  setToken(token: string): void {
    this.token = token;
    localStorage.setItem('token', token);
  }

  getToken(): string | null {
    return this.token;
  }

  logout(): void {
    this.token = null;
    localStorage.removeItem('token');
  }

  isAuthenticated(): boolean {
    return !!this.token;
  }
}

export default new AuthService();